import {z} from 'zod/v4';

import {objectIdStringZ4} from '@packages/utilities/zod';

/**
 * Product cap for a site-branch description on write. Storage allows more
 * headroom; this is the limit callers see.
 */
export const MAX_SITE_BRANCH_DESCRIPTION_REQUEST_LENGTH = 300;

/** Product cap for a site-branch display name on write. */
export const MAX_SITE_BRANCH_NAME_LENGTH = 256;

/**
 * Request body for `POST /api/sites/:site/site-branches`.
 */
export const CreateSiteBranch = z.object({
  /** User-facing branch name shown in the Designer. */
  name: z.string().trim().min(1).max(MAX_SITE_BRANCH_NAME_LENGTH),
  /** Optional user-provided description for the branch. */
  description: z
    .string()
    .trim()
    .max(MAX_SITE_BRANCH_DESCRIPTION_REQUEST_LENGTH)
    .optional(),
  /** Main-site page the user was viewing when branch creation began. */
  originPageId: objectIdStringZ4.optional(),
});
export type CreateSiteBranch = z.infer<typeof CreateSiteBranch>;

/**
 * Response body for `POST /api/sites/:site/site-branches`.
 */
export const CreateSiteBranchResponse = z.object({
  /** Newly created site-branch ID. */
  branchId: objectIdStringZ4,
  /** Working page corresponding to `originPageId` for entering the branch. */
  destinationPageId: objectIdStringZ4,
});
export type CreateSiteBranchResponse = z.infer<typeof CreateSiteBranchResponse>;
